import { DateTime } from "luxon";

const DATE_FORMAT = {
    year: "numeric",
    month: "short",
    day: "numeric",
};

const DATETIME_FORMAT = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
    hourCycle: "h23",
};

export const formatDate = (
    dateTime: Date | DateTime | undefined | null,
): string => {
    if (!dateTime) {
        return "-";
    }

    let dt: DateTime;

    if (dateTime instanceof DateTime) {
        dt = dateTime;
    } else if (dateTime instanceof Date) {
        dt = DateTime.fromJSDate(dateTime);
    } else {
        return "-";
    }

    return dt.toLocaleString(DATE_FORMAT as unknown);
};

export const formatDateTime = (
    dateTime: Date | DateTime | undefined | null,
): string => {
    if (!dateTime) {
        return "-";
    }

    let dt: DateTime;

    if (dateTime instanceof DateTime) {
        dt = dateTime;
    } else if (dateTime instanceof Date) {
        dt = DateTime.fromJSDate(dateTime);
    } else {
        return "-";
    }

    return dt.toLocaleString(DATETIME_FORMAT as unknown);
};

export const getTimezoneInfo = (
    timezone: string | null | undefined,
    date: Date,
) => {
    if (!timezone) return { offset: undefined, tzName: undefined };
    const localizedDate = DateTime.fromJSDate(date).setZone(timezone);
    if (!localizedDate.isValid) return { offset: undefined, tzName: undefined };
    return {
        offset: localizedDate.toFormat("ZZ"),
        tzName: localizedDate.toFormat("ZZZZ (ZZ)"),
    };
};
